import { modalTypes, IModalState } from './types';

const showModal = (payload: { type: IModalState['type']; data: IModalState['data'] }) => ({
  type: modalTypes.SHOW_MODAL,
  payload,
});

// !Do not use hideModal, use closeModal instead to archive animation
const hideModal = () => ({
  type: modalTypes.HIDE_MODAL,
});

const closeModal = () => ({
  type: modalTypes.CLOSE_MODAL,
});

export { showModal, hideModal, closeModal };
